import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import mainLogo from "assets/images/main-logo.png";
import feather from "feather-icons";
import { showToast } from "toast/toastHelper";
import { useDispatch } from "react-redux";
import { otpReq, otpVerify, otpPassVerify } from "./services/clientServices";
import OtpInp from "./component/OtpInp";
import { ToastContainer, toast } from "react-toastify";
import { login } from "units/auth/store/authSlice";
import { ClipLoader, PulseLoader } from "react-spinners";
import config from "../../config.js";
import AnimatedBackground from "./component/AnimatedBackground";
import { useTheme } from "units/dashboard/context/ThemeProvider";
import { useTranslation } from "react-i18next";

const ClientVerifyRegisterCode = () => {
  const { t } = useTranslation(["client"]);

  const { theme } = useTheme();
  const BASE_URL = config.cdnUrl;
  const [loading, setLoading] = useState(false);
  const [otpCode, setOtpCode] = useState();
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [otp, setOtp] = useState();
  const [error, setError] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { username } = useParams();
  const otpRef = useRef("");
  const mode = location.state?.mode;

  useEffect(() => {
    const expireTime = Number(localStorage.getItem("otpExpireTime"));
    if (!expireTime) return;
    const remaining = Math.floor((expireTime - Date.now()) / 1000);
    setOtpTimer(remaining > 0 ? remaining : 0);
  }, []);

  useEffect(() => {
    if (!mode) {
      navigate(`/${username}`);
    }
  }, [mode]);

  const logo = JSON.parse(localStorage.getItem("logo"));
  useEffect(() => {
    const otpNumber = JSON.parse(localStorage.getItem("otpCode"));
    const otpString = String(otpNumber);
    const countryCode = JSON.parse(localStorage.getItem("countryCode"));
    const localPhone = JSON.parse(localStorage.getItem("phoneNumber"));
    if (otpNumber) setOtpCode(otpString);
    setPhone(localPhone);
    setCountryCode(countryCode);
  }, []);

  const handleOTPComplete = (otp) => {
    setOtp(String(otp));
    otpRef.current = String(otp);
  };

  useEffect(() => {
    const handleEnterPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleClick(otpRef.current);
      }
    };
    document.addEventListener("keydown", handleEnterPress);
    return () => {
      document.removeEventListener("keydown", handleEnterPress);
    };
  }, [otp]);

  const handleClick = async (enteredOtp) => {
    if (otpTimer > 0 && !enteredOtp) return;
    setLoading(true);
    try {
      if (otpTimer > 0) {
        const res =
          mode == "LoginWithOtp"
            ? await otpVerify({ countryCode, phone, otp: enteredOtp })
            : await otpPassVerify({ countryCode, phone, otp: enteredOtp });
        if (res?.ok) {
          setError(false);
          dispatch(
            login({
              accessToken: res?.data?.accessToken,
              refreshToken: res?.data?.refreshToken,
            })
          );
          if (mode == "LoginWithOtp") {
            localStorage.removeItem("otpExpireTime");
            navigate(`/bot/chatbox/${username}`);
          }
          if (mode == "ForgetOrRegister") {
            localStorage.setItem("otpCode", enteredOtp);
            navigate(`/password-verification/${username}`);
          }
        } else {
          setError(true);
        }
      } else if (otpTimer == 0) {
        const payload = { countryCode, phone };
        const res = await otpReq(payload);
        if (res.ok) {
          setOtp(res?.data);
          showToast(t("verifyOtp.codeSentToast"), "success");
          const expireTime = Date.now() + 90 * 1000;
          localStorage.setItem("otpExpireTime", expireTime);
          setOtpTimer(90);
        }
        if (!res.ok) {
          setOtpTimer(res?.error?.remainingSeconds);
          toast.error(res?.error?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setError(true);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (otpTimer <= 0) return;
    const timer = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [otpTimer]);

  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden">
      <AnimatedBackground />

      {/* استایل رینگ چرخان */}
      <style>{`
        @property --ring-angle {
          syntax: "<angle>";
          initial-value: 0deg;
          inherits: false;
        }
        @keyframes ringTravel {
          to { --ring-angle: 360deg; }
        }
        .ring-traveler {
          position: absolute;
          inset: 0;
          border-radius: inherit;
          padding: 2px;
          background: conic-gradient(
            from var(--ring-angle),
            transparent 0deg,
            transparent 250deg,
            rgba(20, 184, 166, 0.15) 270deg,
            #14b8a6 300deg,
            #FFC505 330deg,
            #fff7c2 345deg,
            transparent 360deg
          );
          -webkit-mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
                  mask-composite: exclude;
          animation: ringTravel 4s linear infinite;
          pointer-events: none;
          z-index: 20;
        }
        .ring-glow {
          position: absolute;
          inset: -2px;
          border-radius: inherit;
          padding: 3px;
          background: conic-gradient(
            from var(--ring-angle),
            transparent 0deg,
            transparent 260deg,
            #14b8a6 305deg,
            #FFC505 335deg,
            transparent 360deg
          );
          -webkit-mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
                  mask-composite: exclude;
          filter: blur(8px);
          opacity: 0.85;
          animation: ringTravel 4s linear infinite;
          pointer-events: none;
          z-index: 19;
        }
        .glass-card {
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.78) 0%,
            rgba(255, 255, 255, 0.55) 45%,
            rgba(20, 184, 166, 0.10) 100%
          );
          backdrop-filter: blur(24px) saturate(160%);
          -webkit-backdrop-filter: blur(24px) saturate(160%);
          border: 1px solid rgba(255, 255, 255, 0.55);
        }
        .glass-card::before {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: inherit;
          pointer-events: none;
          background:
            radial-gradient(circle at 20% 0%, rgba(255, 197, 5, 0.15), transparent 55%),
            radial-gradient(circle at 100% 100%, rgba(20, 184, 166, 0.15), transparent 55%);
        }
        .dark .glass-card {
          background: linear-gradient(
            135deg,
            rgba(15, 63, 58, 0.55) 0%,
            rgba(10, 35, 32, 0.65) 45%,
            rgba(20, 184, 166, 0.10) 100%
          );
          border: 1px solid rgba(94, 234, 212, 0.25);
        }
      `}</style>

      {/* نمایش کد OTP فقط در توسعه */}
      {otpCode && window.location.hostname !== "rayabot.ir" && (
        <div className="relative z-10 bg-gradient-to-r from-yellow-300 via-yellow-400 to-teal-400 text-[#0f3f3a] p-4 rounded-2xl shadow-[0_10px_30px_-10px_rgba(255,197,5,0.7)] dark:!shadow-[0_10px_30px_-10px_rgba(20,184,166,0.7)] mt-4 text-center w-[350px] mb-5 backdrop-blur-md border border-white/60 dark:!border-teal-300/30">
          <p className="text-sm font-semibold opacity-80">{t("verifyOtp.devCodeLabel")}</p>
          <p className="text-2xl font-bold tracking-[0.4em] mt-1">{otpCode}</p>
        </div>
      )}

      <div className="relative z-10 max-w-md w-[350px] mx-auto">
        {/* کارت شیشه‌ای با رینگ چرخان */}
        <div className="relative rounded-3xl glass-card shadow-[0_20px_60px_-15px_rgba(20,184,166,0.35),0_8px_30px_-10px_rgba(255,197,5,0.25)] dark:!shadow-[0_20px_60px_-15px_rgba(20,184,166,0.5),0_8px_30px_-10px_rgba(255,197,5,0.35)]">
          {/* هاله‌ی محو پشت نور */}
          <div className="ring-glow rounded-3xl" />
          {/* نور دنباله‌دار روی لبه */}
          <div className="ring-traveler rounded-3xl" />

          <div className="relative z-10 p-8 rounded-3xl overflow-hidden">
            {/* هایلایت شیشه بالای کارت */}
            <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-white/60 dark:!from-teal-200/10 to-transparent rounded-t-3xl" />

            {otpTimer > 0 && (
              <div className="absolute w-12 h-12 left-2 top-2 z-20">
                <ClipLoader
                  color="#FFC505"
                  size={48}
                  speedMultiplier={0.5}
                  loading={true}
                />
                <span className="absolute inset-0 flex items-center justify-center text-gray-700 dark:!text-teal-100 text-sm font-bold">
                  {otpTimer}
                </span>
              </div>
            )}

            <div className="relative z-10 rounded-full w-fit mx-auto">
              <Link to={`/${username}`}>
                <img
                  src={logo ? `${BASE_URL}${logo}` : "/defaultLogo.png"}
                  alt="logo"
                  className="w-[150px] h-[150px] mx-auto block rounded-full object-cover mb-5 mt-2 ring-2 ring-teal-200/70 dark:!ring-teal-400/40 shadow-[0_0_25px_-5px_rgba(255,197,5,0.55)] dark:!shadow-[0_0_25px_-5px_rgba(20,184,166,0.65)]"
                  onError={(e) => {
                    e.currentTarget.src = "/defaultLogo.png";
                  }}
                />
              </Link>
            </div>

            <h2 className="relative z-10 text-center text-l font-bold mb-4 bg-gradient-to-r from-teal-700 via-[#1f3e39] to-yellow-600 dark:!from-teal-300 dark:!via-teal-100 dark:!to-yellow-300 bg-clip-text text-transparent">
              {t("verifyOtp.title")}
            </h2>

            <div className="relative z-10 flex justify-center">
              <OtpInp length={5} onComplete={handleOTPComplete} />
            </div>

            {error && (
              <p className="text-red-600 dark:!text-red-400 text-sm mt-3 text-center">
                {t("verifyOtp.invalidCode")}
              </p>
            )}

            <div className="relative z-10 mt-5">
              <button
                onClick={() => handleClick(otp)}
                disabled={loading}
                type="submit"
                className="
                  relative w-full py-3 px-4 text-sm tracking-wide rounded-xl
                  text-white font-bold

                  bg-gradient-to-r from-teal-700 via-teal-600 to-teal-500
                  dark:!from-teal-600 dark:!via-teal-500 dark:!to-teal-400

                  hover:from-teal-800 hover:via-teal-700 hover:to-teal-600
                  dark:!hover:from-teal-500 dark:!hover:via-teal-400 dark:!hover:to-teal-300

                  shadow-[0_10px_25px_-8px_rgba(13,148,136,0.7)]
                  dark:!shadow-[0_10px_25px_-8px_rgba(20,184,166,0.9)]

                  hover:shadow-[0_12px_30px_-6px_rgba(20,184,166,0.8)]
                  dark:!hover:shadow-[0_12px_30px_-6px_rgba(94,234,212,0.9)]

                  transition-all duration-300

                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-teal-500
                  dark:!focus:ring-teal-300

                  disabled:opacity-70
                  disabled:cursor-not-allowed
                "
              >
                {!loading ? (
                  otpTimer > 0 ? (
                    t("verifyOtp.verifyCode")
                  ) : (
                    t("verifyOtp.resendCode")
                  )
                ) : (
                  <PulseLoader color="#ffffff" size={9} />
                )}
              </button>
            </div>

            <div className="relative z-10 flex justify-center mt-3">
              <Link
                to={`/${username}`}
                className="text-sm text-teal-700 dark:!text-teal-300 font-bold hover:text-yellow-700 dark:!hover:text-yellow-300 hover:underline transition-colors"
              >
                {t("verifyOtp.back")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientVerifyRegisterCode;